// Adapted from https://github.com/rebassjs/rebass/blob/master/packages/space/src/index.js
import styled from 'styled-components';
import { space, layout, typography, grid, color, flexbox, background, border, position, shadow, compose, system, } from 'styled-system';
import { ChildrenWithClass } from '../tools/components';
const boxSizing = system({
    boxSizing: true,
});
const Styles = styled(ChildrenWithClass) `
  && {
    ${compose(space, layout, typography, grid, color, flexbox, background, border, position, shadow, boxSizing)}
  }
`;
export { Styles };
//# sourceMappingURL=Styles.js.map